import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROJECTS } from "@/data/projects";
import { ProjectCard } from "@/components/ProjectCard";
import { MaskLines, Reveal, SectionLabel } from "@/components/Primitives";

const LAYOUT = [
  { className: "lg:col-span-7", aspect: "aspect-[16/11]" },
  { className: "lg:col-span-4 lg:col-start-9 lg:mt-56", aspect: "aspect-[4/5]" },
  { className: "lg:col-span-5 lg:-mt-24", aspect: "aspect-[4/5]" },
  { className: "lg:col-span-6 lg:col-start-7 lg:mt-24", aspect: "aspect-[16/11]" },
  { className: "lg:col-span-8 lg:col-start-3 lg:mt-16", aspect: "aspect-[16/9]" },
];

export const SelectedWork = () => (
  <section id="work" className="border-t border-line py-28 sm:py-36 lg:py-44" data-testid="work-section">
    <div className="container-x">
      <div className="grid grid-cols-1 items-end gap-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <SectionLabel index="03" label="Selected Work" />
          <MaskLines lines={["Things", "I've Built."]} className="mt-8 font-serif text-6xl font-light leading-[0.95] text-ivory sm:text-7xl lg:text-[7.5rem]" />
        </div>
        <Reveal className="lg:col-span-3 lg:col-start-10">
          <p className="text-ash">A selection of tools, bots, websites and experiments. Each one has its own story.</p>
        </Reveal>
      </div>
      <div className="mt-20 grid grid-cols-1 gap-x-10 gap-y-24 lg:mt-28 lg:grid-cols-12 lg:gap-y-16">
        {PROJECTS.slice(0, 5).map((p, i) => (
          <ProjectCard key={p.slug} project={p} className={LAYOUT[i].className} aspect={LAYOUT[i].aspect} />
        ))}
      </div>
      <Reveal className="mt-28 flex flex-col items-start justify-between gap-8 border-t border-line pt-10 sm:flex-row sm:items-center">
        <p className="font-serif text-3xl font-light italic text-ivory">The full collection, filtered by craft.</p>
        <Link to="/projects" className="btn btn-ghost" data-testid="view-all-projects-btn">
          View All Projects <ArrowRight size={16} />
        </Link>
      </Reveal>
    </div>
  </section>
);
